import React from 'react'
import { Image } from 'react-bootstrap'
import { Link } from 'react-router-dom'

// Banner orizzontale, pensato per un'immagine "larga" (tipo 1200x300).
// "fluid" fa sì che si adatti sempre alla larghezza disponibile
// mantenendo le proporzioni originali — niente ritaglio, niente
// deformazione, funziona sia su mobile sia su desktop.
//
// Tre modi diversi per renderlo cliccabile, a seconda della destinazione:
// - "to": una pagina della SPA React (es. /shop) — usa il router,
//   nessun ricaricamento della pagina
// - "link" con un percorso interno (es. /post/4, /home) — pagine che
//   Django serve direttamente (fuori dalla SPA React, come il blog):
//   serve un ricaricamento vero della pagina, quindi un <a href> normale,
//   nella STESSA scheda
// - "link" con un indirizzo esterno (es. il gruppo Telegram) — apre in
//   una nuova scheda, così il cliente non perde il sito
function Banner({ src = '/static/images/home-banner.png', alt = 'Banner', link, to }) {
  const image = (
    <Image
      src={src}
      alt={alt}
      fluid
      className="w-100 mb-4 rounded"
    />
  )

  if (to) {
    return (
      <Link to={to} className="d-block">
        {image}
      </Link>
    )
  }

  if (link) {
    const isInternal = link.startsWith('/')
    return isInternal ? (
      <a href={link} className="d-block">
        {image}
      </a>
    ) : (
      <a href={link} className="d-block" target="_blank" rel="noreferrer">
        {image}
      </a>
    )
  }

  return image
}

export default Banner